import MDLSection from "../../ui/MDLSection/MDLSection";
import { tsxSection1 } from "./MDLAbout.resources";
import "./MDLAbout.scss";

const PAYPAL_LINK = "https://www.paypal.com/qrcodes/p2pqrc/HVD23G49CMX3A";

const MDLAbout = () => {
  return <div>
    <MDLSection title="Über uns" content={<div>{tsxSection1}</div>}/>
    <h2>Spenden</h2>
    <div id="mdl-card-container">
      <a target="_blank"><img src="mdl-visitenkarte.jpg" alt="Visitenkarte"/></a>
      <div>
        <div>Bankverbindung:</div>
        <div>Sparkasse Schwandorf</div>
        <div>DE55 7505 1040 0031 8703 63</div>
        {/* <div>PayPal:</div>
        <a target="_blank" href={PAYPAL_LINK}>{PAYPAL_LINK}</a> */}
      </div>
    </div>
  </div>;
};

export default MDLAbout;
